import React from 'react';
import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import SessionMonitor from './components/SessionMonitor';
import { ToastProvider } from './context/toastContext';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

const App = () => {
  return (
    <ThemeProvider>
      <ToastProvider>
      <ScrollToTop />
      <BaseOptionChartStyle />
      <SessionMonitor />
      <Router />
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App
